import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxDataGridModule, DxLookupModule, DxSelectBoxModule, DxSwitchModule } from 'devextreme-angular';
import { FuelParamsEditorModule, GridDefaultModule, GridTitleModule } from 'shared';
import { TabModule } from '../tab/tab.module';
import { TrackerAssignmentGridComponent } from './tracker-assignment-grid/tracker-assignment-grid.component';
import { TrackersGridComponent } from './trackers-grid.component';

@NgModule({
  declarations: [TrackersGridComponent, TrackerAssignmentGridComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    FuelParamsEditorModule,
    GridTitleModule,
    GridDefaultModule,
    DxSwitchModule,
    DxLookupModule,
    DxSelectBoxModule
  ],
  exports: [TrackersGridComponent, TrackerAssignmentGridComponent]
})
export class TrackersGridModule { }
